import { useEffect, useState } from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { CarSlider, Weather, Map, BannerSlider } from "../../components";
import { UserCarForm } from "../../components/Cards";
import iLocation from "../../assets/icons/iLocation.png";

import Car from "../../assets/logos/car.png";
const Index = (props) => {
  const [selectedCar, setSelectedCar] = useState(null);
  const [info, setInfo] = useState({});
  // Хэрэглэгч өөрөө машин нэмэх/засах modal: { open, car }
  const [carForm, setCarForm] = useState({ open: false, car: null });
  useEffect(() => {
    props.request({
      url: `/user/cars`,
      model: "carsinfo",
      method: "POST",
    });
    props.request({
      url: `/timer/list`,
      model: "timerlist",
    });
    props.request({
      url: `/alarm/list`,
      model: "alarmlist",
    });
    props.request({ url: "/user/checklic", model: "licenseinfo" });
    props?.request({ url: "/auth/checklicense" })?.then((res) => {
      if (res.success && res.data) {
        let newAuth = { ...props?._auth, ...res?.data };
        props?.setAuth(newAuth);
      }
    });
  }, []);

  useEffect(() => {
    if (!selectedCar && props?.rescarsinfo && props?.rescarsinfo[0])
      setSelectedCar(props.rescarsinfo[0]);
    // Засварын дараа сонгосон машины мэдээллийг шинэчилнэ
    if (selectedCar && props?.rescarsinfo?.length) {
      const fresh = props.rescarsinfo.find((x) => x.id === selectedCar.id);
      if (fresh && fresh !== selectedCar) setSelectedCar(fresh);
    }
  }, [props?.rescarsinfo]);

  const openAddCar = () => setCarForm({ open: true, car: null });
  const openEditCar = (car) => setCarForm({ open: true, car });
  const closeCarForm = () => setCarForm({ open: false, car: null });

  const getComp = () => {
    if (props?.iscarsinfo === true) {
      return (
        <div className="flex flex-col items-center justify-center h-full p-10">
          <img src={Car} alt="Car" className="w-3/6" />
          <h2 className="text-2xl font-bold text-center text-gray-700 dark:text-white">
            Түр хүлээнэ үү....
          </h2>
        </div>
      );
    } else if (!props?.rescarsinfo || props?.rescarsinfo?.length === 0) {
      return (
        <div className="flex flex-col items-center justify-center h-full p-10">
          <img src={Car} alt="Car" className="w-3/6" />
          <h2 className="text-2xl font-bold text-center text-gray-700 dark:text-white">
            {props?.translate("main.nocar")}
          </h2>

          <p className="mt-3 text-gray-500 dark:text-gray-300 text-center">
            {props?.translate("main.nocardesc")}
          </p>
          <p className="mt-1 text-gray-500 dark:text-gray-300 text-center">
            {props?.translate("main.addcardesc")}
          </p>
          <Button
            type="primary"
            size="large"
            icon={<PlusOutlined />}
            className="mt-5"
            onClick={openAddCar}
          >
            {props?.translate("main.addcar")}
          </Button>
        </div>
      );
    } else {
      return (
        <CarSlider
          data={props?.rescarsinfo}
          {...props}
          selectedCar={selectedCar}
          setSelectedCar={setSelectedCar}
          info={info}
          setInfo={setInfo}
          onEditCar={openEditCar}
        />
      );
    }
  };

  const hasCars = props?.rescarsinfo?.length > 0 && props?.iscarsinfo !== true;

  return (
    <div className="grid grid-cols-12 gap-2 sm:gap-2 md:gap-8 h-full overflow-y-auto">
      <div className="relative h-full bg-white dark:bg-card col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-7 xl:col-span-6 2xl:col-span-5 rounded-2xl border shadow-lg border-light_border dark:border-border ">
        {hasCars ? (
          <Button
            icon={<PlusOutlined />}
            title={props?.translate("main.addcar")}
            className="absolute top-3 right-3 z-10 flex items-center"
            onClick={openAddCar}
          >
            {props?.translate("main.addcar")}
          </Button>
        ) : null}
        {getComp()}
      </div>
      <UserCarForm
        {...props}
        open={carForm.open}
        car={carForm.car}
        onClose={closeCarForm}
      />
      <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-5 xl:col-span-6 2xl:col-span-7 flex flex-col gap-2 sm:gap-2 md:gap-8">
        <div className="col-span-12 bg-white dark:bg-card rounded-2xl border shadow-lg border-light_border dark:border-border p-8 flex flex-col">
          <div className="flex flex-col md:flex-row md:items-center">
            <span className="font-bold text-2xl">
              {props.translate("main.weather")}
            </span>
            <div className="flex items-center md:ml-6">
              <img src={iLocation} alt="iLocation" className="icon w-4 h-4 " />
              <span className="ml-2">{props.translate("main.location")}</span>
            </div>
          </div>
          <Weather
            {...props}
            loading={props?.isweather === true}
            data={
              props?.isweather === true
                ? { temperature_2m: new Array(24).fill(null) }
                : props?.resweather?.hourly
            }
          />
        </div>
        <div className="col-span-12 h-96 md:h-full dark:bg-card rounded-2xl border shadow-lg border-light_border dark:border-border p-4">
          {selectedCar?.islocation ? (
            <Map selectedCar={selectedCar} info={info} {...props} />
          ) : (
            <BannerSlider data={props?.resbanners} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Index;
